export const regexPhoneNumber = (phone: string) => {
  const regexPhoneNumber = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;
  return phone.match(regexPhoneNumber) ? true : false;
}

export function isNumeric(str: string) {
  console.log(str, parseFloat(str), !isNaN(parseFloat(str)))
  return !isNaN(parseFloat(str))
}

/**
 * Generate random coordinates close to a given center point
 * @param center - [latitude, longitude] center coordinates
 * @param radius - radius in degrees (default: 0.005 which is roughly 500m)
 * @returns [latitude, longitude] random coordinates
 */
export const generateRandomCoordinates = (center: [number, number], radius: number = 0.005): [number, number] => {
  // Generate random angle and distance
  const angle = Math.random() * 2 * Math.PI;
  const distance = Math.random() * radius;

  // Convert polar coordinates to cartesian
  const deltaLat = distance * Math.cos(angle);
  const deltaLng = distance * Math.sin(angle);

  // Add to center coordinates and ensure bounds
  let randomLat = center[0] + deltaLat;
  let randomLng = center[1] + deltaLng;

  // Ensure latitude is within valid range (-90 to 90)
  randomLat = Math.max(-90, Math.min(90, randomLat));

  // Ensure longitude is within valid range (-180 to 180)
  randomLng = Math.max(-180, Math.min(180, randomLng));

  return [randomLng, randomLat];
};